<template>
    <div>
        <span>{{getDate.created}}</span>
        <span class="d-block font-weight-normal">{{getDate.updated}}</span>
    </div>
</template>

<script>
    import fecha from 'fecha'
    export default {
        name: 'DateStatusColumn',
        props: {
            date: {
                type: Object,
                required: true
            }
        },
        computed: {
            getDate() {
                return {
                    created: this.convertDate(this.date.created),
                    updated: this.convertDate(this.date.updated)
                }
            }
        },
        methods: {
            convertDate(date) {
                if (!date) {
                    return ''
                }
                return fecha.format(new Date(date), 'DD/MM/YYYY HH:mm:ss')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/DateStatusColumn.vue